<script>
export default {
  props: {
    border: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      searchQuery: null,
    }
  },
  methods: {
    handleSearch(query) {
      this.$emit('searchChanged', query)
    },
  },
}
</script>

<template>
  <div :class="$style.searchWrapper">
    <input
      v-model="searchQuery"
      type="text"
      name="search"
      class="form-control"
      :placeholder="$t('Type your search here') + '...'"
      :class="[$style.searchInput, border !== false ? $style.hasBorder : '']"
      @change="handleSearch(searchQuery)"
    />
    <BIconSearch :class="$style.searchIcon"></BIconSearch>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.searchWrapper {
  position: relative;
  .searchIcon {
    position: absolute;
    top: 1.4rem;
    right: 2.25rem;
    font-size: 1.5em;
  }
  .searchInput {
    height: 4.5rem;
    padding-right: 4rem;
    padding-left: 2.5rem;
    font-size: 1.4em;
    font-style: italic;
    border: none;
    border-bottom: 1px solid gray;
    border-radius: $radius;
    &.hasBorder {
      border: 2px solid $gray;
    }
    &:focus {
      box-shadow: none;
    }
  }
}
</style>
